<div ngSt class="package__container" [ngClass]="{'affiliate__package' : isAffiliateProgram() && isAffiliatePackage()}">
  <!-- FLAGGING -->
  @if (data()?.ribbon_text?.length && isAffiliateProgram() && isAffiliatePackage()) {
  @for (item of data()?.ribbon_text; track $index) {
  <div item class="flagging">{{item}}</div>
  }
  }

  <div class="wrap" [ngClass]="isAffiliateProgram() ? 'wrap__affiliate' : 'wrap__promo'">
    <!-- PERIODE -->
    @if(isAffiliateProgram() && data()?.end_time && isAffiliatePackage()){
    <div class="period">{{'package.endsAt' | translate}} {{data()?.end_time}} WIB</div>
    }

    <!-- PACKAGE NAME -->
    <div [ngClass]="isAffiliateProgram() ? 'title__affiliate' : 'title__promo'" class="title">{{data()?.name}}</div>

    <!-- PACKAGE VALIDITY -->
    <div [ngClass]="isAffiliateProgram() ? 'validity__affiliate' : 'validity__promo'" class="validity">
      {{data()?.validity}}</div>

    <!-- PRICE -->
    <div class="price__section">
      <div [ngClass]="isAffiliateProgram() ? 'price__affiliate' : 'price__promo'" class="price">{{data()?.price ??
        '0' | currency}}</div>
      @if(data()?.originalprice && data()?.originalprice !== 0 && !isAffiliateProgram()){
      <div class="original__price">{{data()?.originalprice ?? 0 | currency}}</div>
      }
    </div>

    <!-- ORIGINAL PRICE WITH DISCOUNT -->
    @if(isAffiliateProgram() && hasValueOriginalPrice()){
    <app-original-price [originalprice]="data()?.originalprice" [discount]="data()?.discountPercentage" />
    }

        <!-- SALES PROGRESS BAR -->
        @if (isAffiliateProgram() && isAffiliatePackage()) {
          <div class="mt-auto">
            <app-sales-progress-bar [purchasePercentage]="data()?.purchasePercentage ?? 0" />
          </div>
        }
    </div>
</div>
